import React from 'react';
import { View, Text, Image, ActivityIndicator } from 'react-native';
import PropTypes from 'prop-types';
import get from "../api/methods/get";
import {SpinnerControl} from "./SpinnerControl";

class ImageDisplay extends React.Component {

    state = {
        isLoading: false,
        base64ToRender: null,
    };

    fetchImage = async () => {
        if (this.state.isLoading) return;
        this.setState({ isLoading: true });

        try {
            let response = await get(this.props.imageUrl, this.props.authToken);
            let responseJson = await response.json();
            this.setState({ base64ToRender: responseJson.data });
        } catch (e) {
            console.log(e);
        }

        this.setState({ isLoading: false });
    };

    componentDidMount() {
        this.fetchImage()
    }

    render() {


        return (
            <View style={[{ height: 128, width : 128, justifyContent: 'center', alignItems: 'center' }, this.props.propsContainerStyle]}>

                <SpinnerControl isFetching={this.state.isLoading} />

                {
                    this.state.base64ToRender !== null &&
                    <Image
                        source={{ uri: `data:image/jpeg;base64,${this.state.base64ToRender}` }}
                        style={[{ height: 128, width: 128, borderRadius: 8 }, this.props.propsImageStyle]}
                        resizeMode={this.props.resizeMode === undefined ? 'contain' : this.props.resizeMode}
                    />
                }

            </View>
        )
    }

}

ImageDisplay.propTypes = {
    imageUrl: PropTypes.string.isRequired,
    authToken: PropTypes.string,
    propsImageStyle: PropTypes.object
};

export { ImageDisplay };
